<template>
  <v-data-table
    class="pt-2 mytable"
    :headers="encabezados"
    :items="datosFiltrados"
    :page.sync="pagina"
    :items-per-page.sync="itemsPorPagina"
    :loading="cargando"
    :item-class="claseFila"
    hide-default-footer
    :footer-props="opcionesPaginacion"
  >
    <template #item.NumeroDocumento="{ item }">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <a
            :class="['enlace-editar', colorBloqueo(item.Bloqueado)]"
            v-on="on"
            v-bind="attrs"
            @click="editarEmpleado(item)"
          >
            {{ item.NumeroDocumento }}
          </a>
        </template>
        <span>Editar</span>
      </v-tooltip>
    </template>

    <template v-if="tieneMultiplesEmpresas" #item.Disponible="{ item }">
      <v-icon :color="colorEstado(item.Bloqueado)">
        {{ iconoEstado(item.Disponible) }}
      </v-icon>
    </template>

    <template #item.Bloqueado="{ item }">
      <v-icon :color="colorEstado(item.Bloqueado)">
        {{ iconoEstado(item.Bloqueado) }}
      </v-icon>
    </template>

    <template #item.FechaIngreso="{ item }">
      {{ formatearFecha(item.FechaIngreso) }}
    </template>

    <template #item.FechaContratoHasta="{ item }">
      {{ item.FechaContratoHasta ? formatearFecha(item.FechaContratoHasta) : '-' }}
    </template>

    <template #item.TipoContrato.DescTipoContrato="{ item }">
      {{ item.TipoContrato?.DescTipoContrato || '-' }}
    </template>

    <template v-if="puedeVerSalario" #item.Salario="{ item }">
      {{ formatterMoney(item.Salario, 0) }}
    </template>

    <template v-if="tieneMultiplesEmpresas" #item.cartera="{ item }">
      <v-icon
        title="Ver Cartera"
        class="mr-2"
        color="primary"
        @click="verCartera(item)"
      >
        description
      </v-icon>
    </template>

    <template #footer>
      <data-table-pagination
        :pagina="pagina"
        :items-por-pagina="itemsPorPagina"
        :total-items="totalItemsFiltrados"
        @update:pagina="actualizarPagina"
        @update:items-por-pagina="actualizarItemsPorPagina"
      />
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment';

import DataTablePagination from '../../../../components/Table/DataTablePagination.vue';
import { paginacionMixin } from '../../../../mixins/paginacionMixin.js';
import { formatterMoney } from '../../../../utils/formatearMonedaUtil.js';
import { getColor } from '../Helper/empleadoHelper.js';

export default {
  name: 'TablaEmpleados',

  components: {
    DataTablePagination,
  },

  mixins: [paginacionMixin],

  props: {
    cargando: {
      type: Boolean,
      default: false,
    },
    empleados: {
      type: Array,
      required: true,
    },
    terminoBusqueda: {
      type: String,
      default: '',
    },
    puedeVerSalario: {
      type: Boolean,
      default: false,
    },
    tieneMultiplesEmpresas: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    encabezados() {
      const headers = [
        { text: 'Número Dcto', value: 'NumeroDocumento', align: 'center', width: 130 },
        { text: 'Empleado', value: 'nombreCompleto', align: 'center' },
        { text: 'Cargo', value: 'Cargo', align: 'center' },
        { text: 'Compañía', value: 'DescCompañia', align: 'center' },
        { text: 'Sucursal', value: 'DescripcionSucursal', align: 'center' },
      ];

      if (this.tieneMultiplesEmpresas) {
        headers.push({
          text: 'Disponible',
          value: 'Disponible',
          align: 'center',
          sortable: false,
        });
      }

      headers.push(
        {
          text: 'Bloqueo Cartera',
          value: 'Bloqueado',
          align: 'center',
          sortable: false,
        },
        { text: 'Fecha Ingreso', value: 'FechaIngreso', align: 'center' },
        {
          text: 'Fecha Contrato Hasta',
          value: 'FechaContratoHasta',
          align: 'center',
        },
        {
          text: 'Tipo Contrato',
          value: 'TipoContrato.DescTipoContrato',
          align: 'center',
        }
      );

      if (this.puedeVerSalario) {
        headers.push({ text: 'Salario', value: 'Salario', align: 'center' });
      }

      if (this.tieneMultiplesEmpresas) {
        headers.push({ text: 'Cartera', value: 'cartera', align: 'center', sortable: false });
      }

      return headers;
    },

    datosParaPaginar() {
      return this.empleados;
    },

    opcionesPaginacion() {
      return { itemsPerPageOptions: [10, 50, 100, -1] };
    },
  },

  watch: {
    terminoBusqueda(valor) {
      this.search = valor;
    },
  },

  methods: {
    formatterMoney,

    editarEmpleado(item) {
      this.$emit('edit-item', item);
    },

    verCartera(item) {
      this.$emit('ver-cartera', item);
    },

    iconoEstado(activo) {
      return activo ? 'check_box' : 'check_box_outline_blank';
    },

    colorEstado(bloqueado) {
      return bloqueado ? 'error' : 'primary';
    },

    colorBloqueo(bloqueado) {
      return getColor(bloqueado);
    },

    claseFila(item) {
      return getColor(item.Bloqueado);
    },

    formatearFecha(fecha) {
      return fecha ? moment.utc(fecha).format('YYYY-MM-DD') : '';
    },
  },
};
</script>

<style scoped>
.enlace-editar {
  text-decoration: underline;
}
</style>
